// Tastatursnarveier + hjelp-overlay (?). Muskelminne-vennlig, ett tastetrykk
// for de vanligste handlingene. ⌘K/Ctrl-K håndteres separat av paletten.
export interface Shortcut {
  key: string; // enkelttast, f.eks. 'm', 'g', 'd'
  label: string;
  run: () => void;
}

export function installShortcuts(shortcuts: Shortcut[], onPalette: () => void): void {
  const map = new Map(shortcuts.map((s) => [s.key.toLowerCase(), s]));
  const help = buildHelp(shortcuts);

  document.addEventListener('keydown', (e) => {
    // ⌘K / Ctrl-K → palett.
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      onPalette();
      return;
    }
    // Ikke kapre taster mens man skriver i et felt.
    const t = e.target as HTMLElement;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    if (e.metaKey || e.ctrlKey || e.altKey) return;

    if (e.key === '?') { help.classList.toggle('show'); return; }
    if (e.key === 'Escape') { help.classList.remove('show'); return; }
    const s = map.get(e.key.toLowerCase());
    if (s) { e.preventDefault(); s.run(); }
  });
}

function buildHelp(shortcuts: Shortcut[]): HTMLElement {
  const overlay = document.createElement('div');
  overlay.className = 'help-overlay';
  const box = document.createElement('div');
  box.className = 'help-box';
  box.innerHTML = '<h3>Tastatursnarveier</h3>';
  const rows =
    [{ key: '⌘K', label: 'Kommandopalett' }, ...shortcuts, { key: '?', label: 'Denne hjelpen' }]
      .map((s) => `<div class="help-row"><kbd>${s.key}</kbd><span>${s.label}</span></div>`)
      .join('');
  box.innerHTML += rows;
  overlay.append(box);
  overlay.addEventListener('click', () => overlay.classList.remove('show'));
  document.body.append(overlay);
  return overlay;
}
